import { FunctionComponent } from 'react'
import { CuiMealActions } from 'front-lib'
import { AddToCartButtonProps } from './AddToCartButton.types'
import { useMealActions } from 'src/hooks/coreUx/useMealActions'

export const AddToCartButton: FunctionComponent<AddToCartButtonProps> = ({
  attributes,
  product,
  index
}) => {
  const mealActionsProps = useMealActions(
    product,
    attributes.actions.onAdd,
    attributes.actions.onRemove
  )

  return (
    <CuiMealActions {...mealActionsProps} isEditable={true} index={index} />
  )
}
